(function () {
    "use strict";

    angular.module("app").component("installationCertificate", {
        templateUrl: "@/installation/installation-certificate.html",
        controller: ClearanceController,
        controllerAs: "vm",
        bindings: {
            certificate: "="
        }
    });

    ClearanceController.$inject = ["controllerDecorator", "habilDate","installationCertificate",];
    function ClearanceController(controllerDecorator, habilDate, installationCertificate) {
        const vm = this;
        controllerDecorator.Decorate(vm, []);

        vm.download = download;
        
        vm.getStyle = getStyle;

        function getStyle() {
            const expirationDate = habilDate.GetDateOnly(vm.certificate.ValidUntil);
            const today = habilDate.GetDateOnly(new Date());

            const warningDate = habilDate.AddMonths(today, 12);

            if (expirationDate.valueOf() < today.valueOf())
                return "bg-danger";
            if (expirationDate.valueOf() < warningDate.valueOf())
                return "bg-warning";

            return "bg-success";
        }

        function download() {
            vm.SetLoadingState(true);
            installationCertificate.Download(vm.certificate.PublicId, vm.ShowError, () => vm.SetLoadingState(false));
        }
    }
})();
